



































import Vue from 'vue';
import { mapActions } from 'vuex';
import { Component, Prop, Watch } from 'vue-property-decorator';

@Component({
    methods: mapActions('esb-exec', { execESB: 'create' }),
    components:{
        VEditor: require('vue2-ace-editor')
    }
})
export default class DialogTestLogic extends Vue {
    @Prop({ default: null })
    targetLogic!: string;

    @Prop({ default: () => null })
    save: any;

    execESB: any;

    dialog = false;
    loading = false;
    form = '{  }';
    error = {
        show: false,
        message: ''
    };
    result: string | null = null;
    esbLogs: any[] | null = null;

    @Watch('dialog')
    unInitialize(nv: boolean) {
        if(nv) {
            this.error.show = false;
            this.error.message = '';
            this.result = null;
            this.esbLogs = null;
            this.form = '{  }';
        }
    }

    public initEditor(editor: any) {
        require('brace/ext/language_tools');
        require('brace/mode/json');
        require('brace/theme/chrome');
    }

    public async onRun() {
        try {
            this.loading = true;
            this.error.show = false;
            this.error.message = '';
            await this.save();
            const data = JSON.parse(this.form);
            const response = await this.execESB({
                ...data,
                id: this.targetLogic
            });
            
            if (response.esb_logs) {
                this.esbLogs = response.esb_logs;
                delete response.esb_logs;
            } else {
                this.esbLogs = null;
            }

            this.result = JSON.stringify(response, null, '\t');
        } catch(err) {
            this.error.show = true;
            this.error.message = err.message;
        } finally {
            this.loading = false;
        }
    }
}
